export default {"src":"/_next/static/media/calendarTime_40.c30c98e3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};